const SampleTypeIndex = () => import('@/pages/lab/sampletype/SampleTypeIndex');
const SampleTypeSingle = () => import("@/pages/lab/sampletype/SampleTypeSingle");
const SampleTypeDetail = () => import('@/pages/lab/sampletype/SampleTypeDetail');
const SampleTypeAdd = () => import('@/pages/lab/sampletype/SampleTypeAdd');
const SampleTypeEdit = () => import('@/pages/lab/sampletype/SampleTypeEdit');
const SampleTypeSort = () => import('@/pages/lab/sampletype/SampleTypeSort');
const ServiceInstructionEdit = () => import('@/pages/lab/serviceinstruction/ServiceInstructionEdit');
const SampleTypeAnalyteRange = () => import('@/pages/lab/sampletype/SampleTypeAnalyteRange');

export class SampleTypeRoutes {
  constructor() {
    this.route_root = 'sampletypes';
    this.type_single = 'Sample Type';
    this.type_plural = 'Sample Types';

    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            name: `List ${this.type_plural}`,
            component: SampleTypeIndex,
            meta: { requiresAuth: true },
          },
          {
            path: "sort",
            name: `Sort ${this.type_plural}`,
            component: SampleTypeSort,
            meta: { requiresAuth: true },
          },
          {
            path: "add",
            name: `Add ${this.type_single}`,
            component: SampleTypeAdd,
            meta: { requiresAuth: true },
          },
          {
            path: ":sample_type_id",
            component: SampleTypeSingle,
            children: [
              {
                path: "",
                name: `View ${this.type_single}`,
                component: SampleTypeDetail,
                meta: { requiresAuth: true },
              },
              {
                path: "edit",
                name: `Update ${this.type_single}`,
                component: SampleTypeEdit,
                meta: { requiresAuth: true },
              },
              {
                path: "instructions/update",
                name: `Update ${this.type_single} Service Instructions`,
                component: ServiceInstructionEdit,
                meta: { requiresAuth: true },
              },
              {
                path: "analyte-range",
                name: `${this.type_single} Analyte Range`,
                component: SampleTypeAnalyteRange,
                meta: { requiresAuth: true }
              }
            ],
          },
        ],
      },
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}

